export const ActionTypes = {
  // complaint
  FETCH_QUALITY_ASSURANCE_COMPLAINT: 'services/qualityAssurance/fetch_quality_assurance_complaint',
  FETCH_QUALITY_ASSURANCE_COMPLAINT_CHART: 'services/qualityAssurance/fetch_quality_assurance_complaint_chart',
  FETCH_QUALITY_ASSURANCE_COMPLAINT_FACTORY: 'services/qualityAssurance/fetch_quality_assurance_complaint_factory',
  FETCH_QUALITY_ASSURANCE_COMPLAINT_FILES: 'services/qualityAssurance/fetch_quality_assurance_complaint_files',
  SET_QUALITY_ASSURANCE_COMPLAINT_FILES: 'services/qualityAssurance/set_quality_assurance_complaint_files',
  FETCH_QUALITY_ASSURANCE_COMPLAINT_BY_ID: 'services/qualityAssurance/fetch_quality_assurance_complaint_by_id',
  SET_SINGLE_COMPLAINT_OBJ: 'services/qualityAssurance/SET_single_complaint_obj',
  FETCH_QUALITY_ASSURANCE_COMPLAINT_REf_UNIQUE:
    'services/qualityAssurance/fetch_quality_assurance_complaint_ref_unique',
  FETCH_QUALITY_ASSURANCE_EightD_UNIQUE: 'services/qualityAssurance/fetch_quality_assurance_EightD_unique',
  SET_QUALITY_ASSURANCE_EightD_UNIQUE: 'services/qualityAssurance/set_quality_assurance_EightD_unique',
  SET_QUALITY_ASSURANCE_COMPLAINT_REf_UNIQUE: 'services/qualityAssurance/set_quality_assurance_complaint_ref_unique',
  SET_QUALITY_ASSURANCE_COMPLAINT: 'services/qualityAssurance/set_quality_assurance_complaint',
  SET_QUALITY_ASSURANCE_COMPLAINT_CHART: 'services/qualityAssurance/set_quality_assurance_complaint_chart',
  SET_QUALITY_ASSURANCE_COMPLAINT_FACTORY: 'services/qualityAssurance/set_quality_assurance_complaint_factory',
  SET_QUALITY_ASSURANCE_CREATED_UPDATED_COMPLAINT_OBJ:
    'services/qualityAssurance/set_quality_assurance_created_updated_complaint_obj',
  SET_QUALITY_ASSURANCE_COMPLAINT_LOADER_STATUS:
    'services/qualityAssurance/set_quality_assurance_complaint_loader_status',
  SET_QUALITY_ASSURANCE_COMPLAINT_LOADER_CHART_STATUS:
    'services/qualityAssurance/set_quality_assurance_complaint_loader_chart_status',
  SET_QUALITY_ASSURANCE_COMPLAINT_FILE_LOADER_STATUS:
    'services/qualityAssurance/set_quality_assurance_complaint_file_loader_status',
  ADD_UPDATE_QUALITY_ASSURANCE_COMPLAINT: 'services/qualityAssurance/add_update_quality_assurance_complaint',
  DELETE_QUALITY_ASSURANCE_COMPLAINT: 'services/qualityAssurance/delete_quality_assurance_complaint',
  DELETE_QUALITY_ASSURANCE_EIGHTDPROCESS: 'services/qualityAssurance/delete_quality_assurance_eightdprocess',
  UPLOAD_FILES_COMPLAINT: 'services/qualityAssurance/upload_files_complaint',
  UPLOAD_FILES_EIGHTDPROCESS: 'services/qualityAssurance/upload_files_eightdprocess',
  DELETE_FILES_QUALITY_ASSURANCE_COMPLAINT: 'services/qualityAssurance/delete_files_quality_assurance_complaint',
  FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS: 'services/qualityAssurance/fetch_quality_assurance_eightdprocess',
  FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS_BY_ID: 'services/qualityAssurance/fetch_quality_assurance_eightdprocess_by_id',
  ADD_UPDATE_QUALITY_ASSURANCE_EIGHTDPROCESS: 'services/qualityAssurance/add_update_quality_assurance_eightdprocess',
  ADD_UPDATE_QUALITY_ASSURANCE_COMPLAINT_DATA: 'services/qualityAssurance/add_update_quality_assurance_complaint_data',
  SET_QUALITY_ASSURANCE_EIGHTDPROCESS: 'services/qualityAssurance/set_quality_assurance_eightdprocess',
  SET_QUALITY_ASSURANCE_CREATED_UPDATED_EIGHTDPROCESS_OBJ:
    'services/qualityAssurance/set_quality_assurance_created_updated_eightdprocess_obj',
  SET_QUALITY_ASSURANCE_EIGHTDPROCESS_LOADER_STATUS:
    'services/qualityAssurance/set_quality_assurance_eightdprocess_loader_status',
  FETCH_QUALITY_ASSURANCE_TILES_DATA: 'fetch_quality_assurance_tiles_data',
  SET_QUALITY_ASSURANCE_TILES_DATA: 'set_quality_assurance_tiles_data',

  FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS_REF: 'services/qualityAssurance/fetch_quality_assurance_eightdprocess_ref',
  SET_QUALITY_ASSURANCE_EIGHTDPROCESS_REF: 'services/qualityAssurance/set_quality_assurance_eightdprocess_ref',

  FETCH_8D_NOT_ATTACHED: 'services/qualityAssurance/fetch_eightd_not_attached',
  LOADER_8D_NOT_ATTACHED: 'services/qualityAssurance/loader_eightd_not_attached',
  SET_8D_NOT_ATTACHED: 'services/qualityAssurance/set_eightd_not_attached',

  FETCH_COMPLAINT_NOT_ATTACHED: 'services/qualityAssurance/fetch_eightd_not_attached',
  LOADER_COMPLAINT_NOT_ATTACHED: 'services/qualityAssurance/loader_eightd_not_attached',
  SET_COMPLAINT_NOT_ATTACHED: 'services/qualityAssurance/set_eightd_not_attached',

  // Containment Actions Location
  FETCH_CONTAINMENT_ACTIONS_LOCATIONS: 'services/qualityAssurance/fetch_containment_actions_locations',
  SET_CONTAINMENT_ACTIONS_LOCATIONS: 'services/qualityAssurance/set_containment_actions_locations',

  ADD_UPDATE_CONTAINMENT_ACTIONS_LOCATION: 'services/qualityAssurance/add_update_containment_actions_location',
  SET_ADD_UPDATE_CONTAINMENT_ACTIONS_LOCATION: 'services/qualityAssurance/set_add_update_containment_actions_location',
  DELETE_CONTAINMENT_ACTIONS_LOCATION: 'services/qualityAssurance/delete_containment_actions_location',
  FETCH_CONTAINMENT_ACTIONS_LOCATION_BY_ID: 'services/qualityAssurance/fetch_containment_action_location_by_id',
  SET_CONTAINMENT_ACTIONS_LOCATION_BY_ID: 'services/qualityAssurance/set_containment_action_location_by_id',
  SET_CONTAINMENT_ACTIONS_LOCATION_LOADER_STATUS:
    'services/qualityAssurance/set_containment_action_location_loader_status',

  // Containment Actions Metric
  FETCH_CONTAINMENT_ACTIONS_METRICS: 'services/qualityAssurance/fetch_containment_actions_metrics',
  SET_CONTAINMENT_ACTIONS_METRICS: 'services/qualityAssurance/set_containment_actions_metrics',
  FETCH_CONTAINMENT_ACTIONS_METRICS_TYPE_LIST: 'services/qualityAssurance/fetch_containment_actions_metrics_type',
  SET_CONTAINMENT_ACTIONS_METRICS_TYPE_LIST: 'services/qualityAssurance/set_containment_actions_metrics_type',

  ADD_UPDATE_CONTAINMENT_ACTIONS_METRIC: 'services/qualityAssurance/add_update_containment_actions_metric',
  SET_ADD_UPDATE_CONTAINMENT_ACTIONS_METRIC: 'services/qualityAssurance/set_add_update_containment_actions_metric',
  DELETE_CONTAINMENT_ACTIONS_METRIC: 'services/qualityAssurance/delete_containment_actions_metric',
  FETCH_CONTAINMENT_ACTIONS_METRIC_BY_ID: 'services/qualityAssurance/fetch_containment_actions_metric_by_id',
  SET_CONTAINMENT_ACTIONS_METRIC_BY_ID: 'services/qualityAssurance/set_containment_actions_metric_by_id',
  SET_CONTAINMENT_ACTIONS_METRIC_LOADER_STATUS: 'services/qualityAssurance/set_containment_action_metric_loader_status',

  // Step 3
  FETCH_CONTAINMENT_ACTIONS_STEP3_BY_ID: 'services/qualityAssurance/fetch_containment_actions_step3_by_id',
  SET_CONTAINMENT_ACTIONS_STEP3_BY_ID: 'services/qualityAssurance/set_containment_actions_step3_by_id',
  SET_CONTAINMENT_ACTIONS_STEP3_LOADER_STATUS: 'services/qualityAssurance/set_containment_action_step3_loader_status',
  FETCH_FILES_FOR_DOWNLOAD: 'services/qualityAssurance/fetch_files_for_download',
  SET_FILES_FOR_DOWNLOAD: 'services/qualityAssurance/set_files_for_download',
  DELETE_CONTAINMENT_DOC_FILES: 'services/qualityAssurance/delete_job_doc_files',
};

//Containment Actions location action
const fetchContainmentActionsLocations = ({ containmentactionlocationParams }) => ({
  containmentactionlocationParams,
  type: ActionTypes.FETCH_CONTAINMENT_ACTIONS_LOCATIONS,
});

const setContainmentActionsLocations = ({ containmentactionlocationData }) => ({
  containmentactionlocationData,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_LOCATIONS,
});

const addUpdateContainmentActionsLocation = ({
  actionName,
  containmentActionsLocationsObj,
  containmentActionsLocationsParams,
}) => ({
  actionName,
  containmentActionsLocationsObj,
  containmentActionsLocationsParams,
  type: ActionTypes.ADD_UPDATE_CONTAINMENT_ACTIONS_LOCATION,
});

const setaddUpdateContainmentActionsLocation = ({ addUpdateContainmentActionsLocationObj }) => ({
  addUpdateContainmentActionsLocationObj,
  type: ActionTypes.SET_ADD_UPDATE_CONTAINMENT_ACTIONS_LOCATION,
});

const deleteContainmentActionsLocation = ({ locationsId, containmentactionlocationParams }) => ({
  locationsId,
  containmentactionlocationParams,
  type: ActionTypes.DELETE_CONTAINMENT_ACTIONS_LOCATION,
});

const fetchContainmentActionsLocationById = ({ location }) => ({
  location,
  type: ActionTypes.FETCH_CONTAINMENT_ACTIONS_LOCATION_BY_ID,
});

const setContainmentActionsLocationById = ({ containmentActionsLocationById }) => ({
  containmentActionsLocationById,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_LOCATION_BY_ID,
});

const setContainmentActionsLocationLoader = ({ containmentActionsLocationsLoader }) => ({
  containmentActionsLocationsLoader,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_LOCATION_LOADER_STATUS,
});

//Containment Actions metric action
const fetchContainmentActionsMetrics = ({ containmentActionsMetricsParams }) => ({
  containmentActionsMetricsParams,
  type: ActionTypes.FETCH_CONTAINMENT_ACTIONS_METRICS,
});

const setContainmentActionsMetrics = ({ containmentactionmetricData }) => ({
  containmentactionmetricData,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_METRICS,
});

const fetchContainmentActionsMetricsTypes = () => ({
  type: ActionTypes.FETCH_CONTAINMENT_ACTIONS_METRICS_TYPE_LIST,
});

const setContainmentActionsMetricsType = ({ containmentactionmetricTypes }) => ({
  containmentactionmetricTypes,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_METRICS_TYPE_LIST,
});

const addUpdateContainmentActionsMetric = ({
  actionName,
  containmentActionsMetricsObj,
  containmentActionsMetricsParams,
}) => ({
  actionName,
  containmentActionsMetricsObj,
  containmentActionsMetricsParams,
  type: ActionTypes.ADD_UPDATE_CONTAINMENT_ACTIONS_METRIC,
});

const setaddUpdateContainmentActionsMetric = ({ addUpdateContainmentActionsMetricObj }) => ({
  addUpdateContainmentActionsMetricObj,
  type: ActionTypes.SET_ADD_UPDATE_CONTAINMENT_ACTIONS_METRIC,
});

const deleteContainmentActionsMetric = ({ metricId, containmentActionsMetricsParams }) => ({
  metricId,
  containmentActionsMetricsParams,
  type: ActionTypes.DELETE_CONTAINMENT_ACTIONS_METRIC,
});

const fetchContainmentActionsMetricById = ({ metric }) => ({
  metric,
  type: ActionTypes.FETCH_CONTAINMENT_ACTIONS_METRIC_BY_ID,
});

const setContainmentActionsMetricById = ({ containmentActionsMetricById }) => ({
  containmentActionsMetricById,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_METRIC_BY_ID,
});

const fetchContainmentActionsStep3ById = ({ eightDProcessId }) => ({
  eightDProcessId,
  type: ActionTypes.FETCH_CONTAINMENT_ACTIONS_STEP3_BY_ID,
});

const setContainmentActionsStep3ById = ({ containmentActionsStep3 }) => ({
  containmentActionsStep3,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_STEP3_BY_ID,
});

const setContainmentActionsMetricLoader = ({ containmentActionsMetricLoader }) => ({
  containmentActionsMetricLoader,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_METRIC_LOADER_STATUS,
});

const setContainmentActionsStep3Loader = ({ containmentActionsStep3Loader }) => ({
  containmentActionsStep3Loader,
  type: ActionTypes.SET_CONTAINMENT_ACTIONS_STEP3_LOADER_STATUS,
});

// Complaint dashboard
const fetchQualityAssuranceEightDUniqueRef = ({ qualityAssuranceEightDParams }) => ({
  qualityAssuranceEightDParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_EightD_UNIQUE,
});

const fetchQualityAssuranceComplaintUniqueRef = ({ qualityAssuranceComplaintParams }) => ({
  qualityAssuranceComplaintParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_REf_UNIQUE,
});

const fetchQualityAssuranceComplaint = ({ qualityAssuranceComplaintParams }) => ({
  qualityAssuranceComplaintParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT,
});

const fetchQualityAssuranceComplaintChart = ({ qualityAssuranceComplaintParams }) => ({
  qualityAssuranceComplaintParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_CHART,
});

const fetchQualityAssuranceComplaintFactory = ({ qualityAssuranceContactbyidParams }) => ({
  qualityAssuranceContactbyidParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_FACTORY,
});

const fetchQualityAssuranceComplaintById = ({ complaintId }) => ({
  complaintId,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_BY_ID,
});

const fetchComplaintFilesById = ({ complaintId }) => ({
  complaintId,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_FILES,
});

const setComplaintFiles = ({ filesUrl }) => ({
  filesUrl,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_FILES,
});

const setQualityAssuranceComplaint = ({ qualityAssuranceComplaintData }) => ({
  qualityAssuranceComplaintData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT,
});

const setQualityAssuranceComplaintChart = ({ qualityAssuranceComplaintchartData }) => ({
  qualityAssuranceComplaintchartData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_CHART,
});

const setQualityAssuranceEidghtDUniqueRef = ({ qualityAssuranceEidghtDUniqueData }) => ({
  qualityAssuranceEidghtDUniqueData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_EightD_UNIQUE,
});

const setQualityAssuranceComplaintUniqueRef = ({ qualityAssuranceComplaintUniqueData }) => ({
  qualityAssuranceComplaintUniqueData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_REf_UNIQUE,
});

const setQualityAssuranceComplaintFactory = ({ qualityAssuranceContactbyidData }) => ({
  qualityAssuranceContactbyidData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_FACTORY,
});

const setQACreatedUpdatedComplaintObj = ({ qaCreatedUpdatedComplaintObj }) => ({
  qaCreatedUpdatedComplaintObj,
  type: ActionTypes.SET_QUALITY_ASSURANCE_CREATED_UPDATED_COMPLAINT_OBJ,
});

const setSingleComplaintObj = ({ singleComplaintObj }) => ({
  singleComplaintObj,
  type: ActionTypes.SET_SINGLE_COMPLAINT_OBJ,
});

const setQACreatedUpdatedEightdProcessObj = ({ qaCreatedUpdatedEightdProcessObj }) => ({
  qaCreatedUpdatedEightdProcessObj,
  type: ActionTypes.SET_QUALITY_ASSURANCE_CREATED_UPDATED_EIGHTDPROCESS_OBJ,
});

const addUpdateQualityAssuranceComplaint = ({
  actionName,
  qualityAssuranceComplaintObj,
  qualityAssuranceComplaintParams,
}) => ({
  actionName,
  qualityAssuranceComplaintObj,
  qualityAssuranceComplaintParams,
  type: ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_COMPLAINT,
});

const fetchQualityAssuranceEightdProcess = ({ qualityAssuranceEightdProcessParams }) => ({
  qualityAssuranceEightdProcessParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS,
});
const fetchQualityAssuranceEightdProcessRef = () => ({
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS_REF,
});

const fetchQualityAssuranceEightdProcessById = ({ eightdProcess }) => ({
  eightdProcess,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS_BY_ID,
});

const addUpdateQualityAssuranceEightdProcess = ({
  actionName,
  qualityAssuranceEightdProcessObj,
  qualityAssuranceEightdProcessParams,
  isRefresh8DDashboard,
  callback,
}) => ({
  actionName,
  qualityAssuranceEightdProcessObj,
  qualityAssuranceEightdProcessParams,
  isRefresh8DDashboard,
  callback,
  type: ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_EIGHTDPROCESS,
});

const addUpdateQualityAssuranceComplaintData = ({ actionName, complaintFormData, callback }) => ({
  actionName,
  complaintFormData,
  callback,
  type: ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_COMPLAINT_DATA,
});

const setQualityAssuranceEightdProcess = ({ qualityAssuranceEightdProcessData }) => ({
  qualityAssuranceEightdProcessData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_EIGHTDPROCESS,
});

const setQualityAssuranceEightdProcessRef = ({ qualityAssuranceEightdProcessRefData }) => ({
  qualityAssuranceEightdProcessRefData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_EIGHTDPROCESS_REF,
});

const uploadFilesComplaint = ({ actionName, fileList, complaintId }) => ({
  actionName,
  fileList,
  complaintId,
  type: ActionTypes.UPLOAD_FILES_COMPLAINT,
});

const uploadFilesEightdProcess = ({ actionName, fileList, eightdProcess }) => ({
  actionName,
  fileList,
  eightdProcess,
  type: ActionTypes.UPLOAD_FILES_EIGHTDPROCESS,
});

const deleteUploadedFilesOfComplaint = ({ actionName, filesName }) => ({
  actionName,
  filesName,
  type: ActionTypes.DELETE_FILES_QUALITY_ASSURANCE_COMPLAINT,
});

const deleteQualityAssuranceComplaint = ({ complaintId, qualityAssuranceComplaintParams }) => ({
  complaintId,
  qualityAssuranceComplaintParams,
  type: ActionTypes.DELETE_QUALITY_ASSURANCE_COMPLAINT,
});

const deleteQualityAssuranceEightdProcess = ({ id, qualityAssuranceEightdProcessParams }) => ({
  id,
  qualityAssuranceEightdProcessParams,
  type: ActionTypes.DELETE_QUALITY_ASSURANCE_EIGHTDPROCESS,
});

const setQualityAssuranceComplaintLoader = ({ qualityAssuranceComplaintLoader }) => ({
  qualityAssuranceComplaintLoader,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_LOADER_STATUS,
});
const setQualityAssuranceComplaintChartLoader = ({ qualityAssuranceComplaintChartLoader }) => ({
  qualityAssuranceComplaintChartLoader,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_LOADER_CHART_STATUS,
});
const setQualityAssuranceComplaintFileLoader = ({ qualityAssuranceComplaintFileLoader }) => ({
  qualityAssuranceComplaintFileLoader,
  type: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_FILE_LOADER_STATUS,
});

const setQualityAssuranceEightdProcessLoader = ({ qualityAssuranceEightdProcessLoader }) => ({
  qualityAssuranceEightdProcessLoader,
  type: ActionTypes.SET_QUALITY_ASSURANCE_EIGHTDPROCESS_LOADER_STATUS,
});

const fetchQualityAssuranceTilesData = ({ qualityAssuranceComplaintParams }) => ({
  qualityAssuranceComplaintParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_TILES_DATA,
});

const setQualityAssuranceTilesData = ({ qualityAssuranceTilesData }) => ({
  qualityAssuranceTilesData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_TILES_DATA,
});
// 8d not attached with complaint
const fetchEightdNotAttached = () => ({
  type: ActionTypes.FETCH_8D_NOT_ATTACHED,
});

const eightdNotAttachedLoader = ({ eightdNotAttachedLoader }) => ({
  eightdNotAttachedLoader,
  type: ActionTypes.LOADER_8D_NOT_ATTACHED,
});

const setEightdNotAttached = ({ eightdNotAttachedData }) => ({
  eightdNotAttachedData,
  type: ActionTypes.SET_8D_NOT_ATTACHED,
});
// complaint not attached
const fetchComplaintNotAttached = () => ({
  type: ActionTypes.FETCH_COMPLAINT_NOT_ATTACHED,
});
const complaintNotAttachedLoader = ({ complaintNotAttachedLoader }) => ({
  complaintNotAttachedLoader,
  type: ActionTypes.LOADER_COMPLAINT_NOT_ATTACHED,
});

const setComplaintNotAttached = ({ complaintNotAttachedData }) => ({
  complaintNotAttachedData,
  type: ActionTypes.SET_COMPLAINT_NOT_ATTACHED,
});

const fetchFilesForDownload = ({ id, fileName }) => ({
  id,
  fileName,
  type: ActionTypes.FETCH_FILES_FOR_DOWNLOAD,
});

const setFilesForDownload = ({ downloadContainmentActionDocFile }) => ({
  downloadContainmentActionDocFile,
  type: ActionTypes.SET_FILES_FOR_DOWNLOAD,
});

const deleteContainmentActionDocFiles = ({ id, fileName }) => ({
  id,
  fileName,
  type: ActionTypes.DELETE_CONTAINMENT_DOC_FILES,
});

export default {
  fetchEightdNotAttached,
  eightdNotAttachedLoader,
  setEightdNotAttached,
  fetchComplaintNotAttached,
  complaintNotAttachedLoader,
  setComplaintNotAttached,
  fetchQualityAssuranceComplaint,
  fetchQualityAssuranceComplaintById,
  fetchComplaintFilesById,
  setComplaintFiles,
  setSingleComplaintObj,
  setQualityAssuranceComplaint,
  fetchQualityAssuranceComplaintChart,
  setQualityAssuranceComplaintChart,
  setQualityAssuranceComplaintFactory,
  fetchQualityAssuranceComplaintFactory,
  setQualityAssuranceComplaintUniqueRef,
  setQualityAssuranceEidghtDUniqueRef,
  fetchQualityAssuranceComplaintUniqueRef,
  fetchQualityAssuranceEightDUniqueRef,
  addUpdateQualityAssuranceComplaint,
  deleteQualityAssuranceComplaint,
  setQualityAssuranceComplaintLoader,
  setQualityAssuranceComplaintChartLoader,
  setQualityAssuranceComplaintFileLoader,
  uploadFilesComplaint,
  uploadFilesEightdProcess,
  deleteUploadedFilesOfComplaint,
  setQACreatedUpdatedComplaintObj,
  addUpdateQualityAssuranceEightdProcess,
  addUpdateQualityAssuranceComplaintData,
  setQACreatedUpdatedEightdProcessObj,
  fetchQualityAssuranceEightdProcess,
  fetchQualityAssuranceEightdProcessById,
  setQualityAssuranceEightdProcessLoader,
  setQualityAssuranceEightdProcess,
  deleteQualityAssuranceEightdProcess,
  fetchQualityAssuranceTilesData,
  setQualityAssuranceTilesData,
  setQualityAssuranceEightdProcessRef,
  fetchQualityAssuranceEightdProcessRef,

  fetchContainmentActionsLocationById,
  fetchContainmentActionsLocations,
  setContainmentActionsLocations,
  addUpdateContainmentActionsLocation,
  deleteContainmentActionsLocation,
  setContainmentActionsLocationLoader,
  setContainmentActionsLocationById,
  setaddUpdateContainmentActionsLocation,

  fetchContainmentActionsMetricById,
  fetchContainmentActionsMetrics,
  setContainmentActionsMetrics,
  addUpdateContainmentActionsMetric,
  deleteContainmentActionsMetric,
  setContainmentActionsMetricLoader,
  setContainmentActionsStep3Loader,
  setContainmentActionsMetricById,
  setaddUpdateContainmentActionsMetric,
  fetchContainmentActionsMetricsTypes,
  setContainmentActionsMetricsType,

  fetchContainmentActionsStep3ById,
  setContainmentActionsStep3ById,
  fetchFilesForDownload,
  setFilesForDownload,
  deleteContainmentActionDocFiles,
};
